import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { checkIf, getUserRole, UserRoles } from "../../utils";
import { getTenant } from "../../theme";

interface GuardProps {
  children: React.ReactNode;
  setLoaded?: (loaded: boolean) => void;
}

const allowedRoutes = [
  "/",
  "/login",
  "/join",
  "/forgot-password",
  "/about",
  "/privacy",
  "/terms-and-conditions",
  "/support",
  "/contact",
  "/congrats",
  "/partner-application",
  "/app",
  "/homepage",
  "/dietitian-appointment",
];

// Routes that authenticated users cannot access
const unauthenticatedOnlyRoutes = ["/login", "/forgot-password"];

export default function Guard({ children, setLoaded }: GuardProps) {
  const location = useLocation();
  const user = useSelector((state: RootState) => state.user);
  const tenant = getTenant();
  const userRole = getUserRole(user);
  const isAuthenticated = userRole !== UserRoles.ANONYMOUS;

  // Ensure setLoaded is called when component mounts
  useEffect(() => {
    if (setLoaded) {
      setLoaded(true);
      // @ts-ignore
      if (globalThis.App?.hideAppSplash) globalThis.App?.hideAppSplash();
    }
  }, [setLoaded]);

  // If authenticated user tries to access login/forgot-password, redirect to home
  // Note: /join is excluded because ProtectedRoute should handle its redirect to /congrats
  if (isAuthenticated && unauthenticatedOnlyRoutes.includes(location.pathname)) {
    const params = new URLSearchParams(location.search);
    const invitationCode = params.get("code");
    return (
      <Navigate
        to={{
          pathname: "/",
          search: checkIf(invitationCode) ? `?code=${invitationCode}` : "",
        }}
        replace
      />
    );
  }
  return <>{children}</>;
}
